import { arDisplayStatus, hasArAssets, type ArStatusBearing } from "./assetStatus";

/**
 * Whether this product can be placed in AR.
 *
 * ⚠️ This used to read ONLY the asset URLs and ignore `asset_status` entirely.
 * That was not a design choice, it was a workaround: every surface that tested
 * `asset_status === "complete"` was broken for approved products (which carry
 * `ready`), and routing through this helper made some pages appear correct
 * while hiding the underlying vocabulary bug. See src/lib/assetStatus.ts.
 *
 * Now it defers to the normalised display status, which consults the pipeline's
 * own assertion first and falls back to URL evidence for rows written before
 * `asset_status` was reliably terminal. Kept as a named export because a dozen
 * call sites read better with it than with the raw comparison.
 */
export function isArReady(product: ArStatusBearing): boolean {
  return arDisplayStatus(product) === "ready";
}

export { hasArAssets };
